import { atom } from 'recoil';

const hoveredDayAssignmentIdAtom = atom<number | null>({
  key: 'hoveredDayAssignmentId',
  default: null,
});

export default hoveredDayAssignmentIdAtom;
